export default "__VITE_ASSET__IOmLH2jr__"